import fluxoOnlineRoutes from "./fluxoOnline.routes";
import { checkout, escolhaPlano } from "./fluxoFixa.routes";

const HomeView = import(
  /* webpackChunkName: "loading-app" */ "@views/Home.vue"
);

const checkoutFixa = import(
  /* webpackChunkName: "checkout-fixa" */ "@views/checkoutFixa"
);

const MainContainer = import(
  /* webpackChunkName: "main-layout" */ "@layouts/main.vue"
);
const CleanContainer = import(
  /* webpackChunkName: "checkout-layout" */ "@layouts/clean.vue"
);
const ParabensView = import(
  /* webpackChunkName: "parabens" */ "@views/parabens.vue"
);

export default [
  {
    path: "/",
    name: "loadingApp",
    component: () => HomeView,
  },
  {
    path: "/fixa",
    name: "checkoutFixa",
    component: () => checkoutFixa,
  },
  {
    path: "/fixa",
    component: () => CleanContainer,
    children: [...escolhaPlano],
  },
  {
    path: "/fixa",
    component: () => MainContainer,
    children: [...checkout],
  },
  {
    path: "*",
    redirect: "/",
  },
  {
    path: "/",
    redirect: "/",
    component: () => MainContainer,
    children: [...fluxoOnlineRoutes],
  },
  {
    path: "/:tipoOferta/:segmento",
    component: () => CleanContainer,
    children: [
      {
        path: "parabens",
        name: "Parabens",
        component: () => ParabensView,
      },
    ],
  },
];
